import { handleRequest } from '../utilities/requestHandler';

export async function fetchNotifications({ unreadOnly = false, limit = 20, offset = 0, q = "", status = "" } = {}) {
  const params = {
    unreadOnly,
    limit,
    offset,
  };
  if (q) {
    params.q = q;
  }
  if (status) {
    params.status = status;
  }
  const response = await handleRequest("get", "/notifications", params);
  const fallback = {
    items: [],
    total: 0,
    limit,
    offset,
  };

  if (Array.isArray(response?.data)) {
    return {
      items: response.data,
      total: typeof response.total === 'number' ? response.total : response.data.length,
      limit: typeof response.limit === 'number' ? response.limit : limit,
      offset: typeof response.offset === 'number' ? response.offset : offset,
    };
  }

  if (Array.isArray(response)) {
    return { ...fallback, items: response, total: response.length };
  }

  return fallback;
}

export async function fetchUnreadCount() {
  const { data } = await handleRequest("get", "/notifications/unread-count");
  return data?.count || 0;
}

export async function markRead(recipientIds = []) {
  if (!recipientIds.length) return { updated: 0 };
  const { data } = await handleRequest("post", "/notifications/mark-read", {
    recipient_ids: recipientIds
  });
  return { updated: data?.updated || 0 };
}

export async function markUnread(recipientIds = []) {
  if (!recipientIds.length) return { updated: 0 };
  const { data } = await handleRequest("post", "/notifications/mark-unread", {
    recipient_ids: recipientIds
  });
  return { updated: data?.updated || 0 };
}

export async function deleteNotifications(recipientIds = []) {
  if (!recipientIds.length) return { deleted: 0, unread_deleted: 0 };
  const { data } = await handleRequest("post", "/notifications/delete", {
    recipient_ids: recipientIds
  });
  return { deleted: data?.deleted || 0, unread_deleted: data?.unread_deleted || 0 };
}

export async function fetchCcrSubmission(submissionId) {
  if (!submissionId) return null;
  const response = await handleRequest("get", `/machines/contact-ccr/submissions/${submissionId}`);
  return response?.data?.submission || response?.submission || null;
}

export async function fetchPurchaseRequestSubmission(submissionId) {
  if (!submissionId) return null;
  const response = await handleRequest("get", `/orders/purchase-request/submissions/${submissionId}`);
  return response?.data?.submission || response?.submission || null;
}